<template>
  <router-view />
</template>

<script>
export default {
  data () {
    return {
      pageTitle: 'Tracking',
      breadcrumb:
      {
        name: 'Tracking',
        route: { name: 'manage-carriers-carrier-tracking' }
      },
      sidebar:
      [
        {
          icon: ['fal', 'address-card'],
          route: { name: 'manage-carriers-carrier-tracking-seeds' },
          name: 'Seeds'
        }
      ]
    }
  }
}
</script>
